import React from "react";
import imgElastin from "../images/homepage/Elastin_Details.jpg";
import imgClarifying from "../images/homepage/clarifying_Shampoo_1.jpg";
import imgKeratin from "../images/homepage/Keratin__Treatment_1.jpg";
import imgSilkTouchShampoo from "../images/homepage/Sts.jpg";
import imgSilkTouchConditioner from "../images/homepage/stc.jpg";
import imgNanoplastia from "../images/homepage/repair.png";
import imgBioLockShampoo from "../images/homepage/sampoooo.jpg";
import imgBioLockConditioner from "../images/homepage/condition.jpg";

export default function Products() {
  const collection = [
    {
      title: "Elastin",
      image: imgElastin,
      desc: "Rich in KERATRIPLEX, a blend of special protein and minerals which helps in chemically treated hair. It creates a chain of fiber protein which results in hair by protecting the hydro-lipid layer, preventing the action of external moisture, reinforcing the hair fiber and aligning them to the desired shape. It manages the hair volume and gives lustrous shine, amazing smoothness and finest result for all hair type."
    },
    {
      title: "Clarifying Shampoo",
      image: imgClarifying,
      desc: "Ensures maximum performance when used before Calyx Keratin Treatment. Washes away minerals, chlorine and water deposits to revitalise dull hair and create the best hair condition for Calyx Fibre Protein Reconstructor."
    },
    {
      title: "Keratin Treatment",
      image: imgKeratin,
      desc: "Contains various amino acids ingredients to rejuvenate dull, tangled and dry hair. This special formula nourishes your hair naturally through the use of heat and penetrates from root to tip. Leaving hair smooth and silky. Maintains moisture and PH level."
    },
    {
      title: "Silk Touch Shampoo",
      image: imgSilkTouchShampoo,
      desc: "Calyx Silk Touch shampoo is exclusively designed for Calyx Keratin Treatment and daily use. It is made from natural fruit extracts that maintains the natural PH balance of the hair."
    },
    {
        title: "Silk Touch Conditioner",
        image: imgSilkTouchConditioner,
        desc: "A fruit rich in antioxidants to revitalise hair and deliver super conditioning and prismatic shine to the hair after Calyx Keratin Treatment. Ideal for making hair clean, healthy and full of body."
    },
    {
        title: "Calyx Nanoplastia Treatment",
        image: imgNanoplastia,
        desc: "Advanced, formaldehyde-free hair transformation treatment designed to deliver glass-like shine, frizz control, and naturally straight, healthy-looking hair for up to 5–6 months."
    },
    {
        title: "Calyx BioLock Shampoo",
        image: imgBioLockShampoo,
        desc: "A sulfate-free, paraben-free formula created especially to maintain and prolong the results of Nanoplastia and other smoothing treatments. Protects hair bonds from breakage."
    },
    {
        title: "Calyx BioLock Conditioner",
        image: imgBioLockConditioner,
        desc: "The Calyx BioLock Conditioner deeply hydrates the hair shaft, locking in moisture and sealing cuticles after every wash. Specially formulated to work with Nanoplastia and smoothing treatments."
    }
  ];

  return (
    <div className="products-section">
      <div className="container">
        <h2>Our Premium Collection</h2>
        <p className="section-subtitle">Professional-grade hair care for every hair type</p>
        
        <div className="products-grid-container">
          {collection.map((item, index) => (
            <div key={index} className="product-card-item">
              <div className="product-image-box">
                <img src={item.image} alt={item.title} />
              </div>
              <div className="product-info-box">
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
